import { z } from "zod";

export const step1Schema = z.object({
  firstName: z.string().min(1, "form.errors.nameRequired").max(100),
  lastName: z.string().min(1, "form.errors.nameRequired").max(100),
  email: z.string().min(1, "form.errors.emailRequired").email("form.errors.emailInvalid"),
});

export const step2Schema = z.object({
  company: z.string().min(1, "form.errors.required").max(200),
  jobTitle: z.string().min(1, "form.errors.required").max(200),
  companySize: z.string().min(1, "form.errors.required"),
  challenge: z.string().max(500).optional(),
});

export const fullFormSchema = step1Schema.merge(step2Schema);

export type Step1Data = z.infer<typeof step1Schema>;
export type Step2Data = z.infer<typeof step2Schema>;
export type FullFormData = z.infer<typeof fullFormSchema>;
